"use client";

import React, { ReactNode } from "react";
import styled from "styled-components"
import { blockStyles, Box } from "@motorata/base-ui.components.atoms._atoms";
import CarShopListSidebar from "../views/carShopList/CarShopListSidebar";
import BusinessProfileSection from "../components/sections/BusinessProfileSection";

const CarShopListTemplate = ({ children, seoChildren }: {
  children: ReactNode
  seoChildren: ReactNode
}) => {
  return (
    <>
      <Content>
        {children}
        <CarShopListSidebar />
      </Content>
      {seoChildren}
      <BusinessProfileSection />
    </>
  )
}

export default CarShopListTemplate

const Content = styled(Box)`
  ${blockStyles};
  margin-top: 0;
  display: grid;
  grid-template-columns: 3fr 1fr;
  grid-gap: ${({ theme }) => theme.space.M};
  max-width: 1300px;
  
  @media (max-width: 1200px){
    grid-template-columns: 2fr 1fr;
  };

  @media (max-width: 950px){
    display: block;
    
    >div:nth-child(1){
      margin-bottom: ${({ theme }) => theme.space.M};
    }
  }
`
